export const state = {
    loading: false,
    bodyBgVariant: '',
    bodyClass: '',
    bodyTextVariant: '',
    busy: false,
    buttonSize: 'md',
    cancelDisabled: false,
    cancelTitle: '',
    cancelVariant: 'secondary',
    centered: false,
    contentClass: '',
    dialogClass: '',
    footerBgVariant: '',
    footerBorderVariant: '',
    footerClass: '',
    footerTextVariant: '',
    fullscreen: false,
    headerBgVariant: '',
    headerBorderVariant: '',
    headerClass: '',
    headerCloseLabel: '',
    headerCloseWhite: false,
    headerTextVariant: '',
    hideBackdrop: false,
    hideFooter: false,
    hideHeader: false,
    hideHeaderClose: false,
    id: '',
    modalClass: '',
    noCloseOnBackdrop: false,
    noCloseOnEsc: false,
    noFade: false,
    noFocus: false,
    okDisabled: false,
    okOnly: false,
    okTitle: '',
    okVariant: 'primary',
    scrollable: false,
    show: false,
    size: '',
    title: '',
    titleClass: '',
    titleSrOnly: false,
    titleTag: 'h5',
    update: 0,
}

export const getters = {
    loading: (state) => {
        return !!state.loading;
    },

    show: (state) => {
        return !!state.show;
    },

    config: (state) => (key) => {
        return state[key];
    },

    version: (state) => {
        return state.version;
    }
}

export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean
    },

    'SET_CONFIG': function (state, obj = {}) {
        Object.keys(obj).forEach(key => {
            state[key] = obj[key];
        })
    },

    'SET_SHOW': function (state, bool = true) {
        state.show = bool;
    },

    'UPDATE': function (state) {
        state.update++;
    }
}

export const actions = {
    init({ commit }) {
        const config = {
            cancelTitle: this.$t('base.cancel').ucFirst(),
            headerCloseLabel: this.$t('base.close').ucFirst(),
            okTitle: this.$t('base.ok').ucFirst()
        };

        commit('SET_CONFIG', config);
    },

    open: function ({ commit }, config = {}) {
        commit('SET_CONFIG', config);
        commit('SET_SHOW', true);
    },

    close: function ({ commit }) {
        commit('SET_SHOW', false);
    },

    clear: function ({commit}) {
        commit('SET_CLEAR_CONFIG', [])
    },

    refresh: function ({ commit }) {
        commit('UPDATE');
    }
}
